import React from 'react'
import './blogpanel.css'
import { Outlet} from 'react-router-dom'

const BlogPanel = () => {


  return (
    <div className='blogPanel_container'>
        <Outlet/>
    </div>
  )
}

export default BlogPanel